import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { closeGroupNameDialog } from './actions';
import { Button } from '@mui/material';
import { all } from 'webui/Z3KConfigParser/validation/collections';
import { minMaxStr, notEmpty } from 'webui/Z3KConfigParser/validation/basic';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
const RenameDialogImpl = memo(function RenameDialogImpl(props) {
    const { dialog_state, onClose } = props;
    const { open, default_group_name, on_ok_function } = dialog_state;
    const [new_title, setNewTitle] = useState(default_group_name);
    const [changed, setChanged] = useState(false);
    const onAccept = useCallback(() => {
        on_ok_function?.(new_title);
        onClose();
    }, [on_ok_function, new_title, onClose]);
    const onAcceptKey = useCallback((event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            onAccept();
        }
    }, [onAccept]);
    const onChange = useCallback((new_value) => {
        setChanged(true);
        setNewTitle(new_value);
    }, [setChanged, setNewTitle]);
    const validate = changed
        ? all(notEmpty, minMaxStr(0, 150))(new_title)
        : null;
    return (_jsx(MessageBox, { open: open, onClose: onClose, maxWidth: "xs", title: "\u0418\u043C\u044F \u0433\u0440\u0443\u043F\u043F\u044B", footer: _jsxs(_Fragment, { children: [_jsx(Button, { onClick: onClose, color: "primary", children: "\u041E\u0442\u043C\u0435\u043D\u0430" }), _jsx(Button, { onClick: onAccept, disabled: validate != null, color: "primary", children: "\u041F\u0440\u0438\u043D\u044F\u0442\u044C" })] }), children: _jsx(Control, { label: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u043E\u0435 \u0438\u043C\u044F \u0433\u0440\u0443\u043F\u043F\u044B", value: new_title, onChange: onChange, field: (input_props) => (_jsx(TextInputWrapper, { ...input_props, autoFocus: true, placeholder: "\u041D\u043E\u0432\u0430\u044F \u0433\u0440\u0443\u043F\u043F\u0430", onKeyPress: onAcceptKey })), help_id: "rename-group-field", validation_result: validate, validation_warnings_result: null }) }));
});
const RenameDialogKey = memo(function RenameDialogKey(props) {
    return _jsx(RenameDialogImpl, { ...props }, props.dialog_state.randomKey);
});
export const RenameGroupDialog = connect(createStructuredSelector({
    dialog_state: (state) => state.rename_group_dialog,
}), { onClose: closeGroupNameDialog })(RenameDialogKey);
